import { defineMessages } from 'react-intl'

const scope = `procurify.modules.spending-cards.features.lock-card-admin`

export default defineMessages({
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage: 'Card locked',
  },
  errorToastMessage: {
    id: `${scope}.errorToastMessage`,
    defaultMessage: 'Could not lock card',
  },
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Do you want to lock this card?',
  },
  modalContent: {
    id: `${scope}.modalContent`,
    defaultMessage:
      'While locked, new purchases will be blocked. Refunds and pre-authorized payments will still be processed.',
  },
  modalConfirmButton: {
    id: `${scope}.modalConfirmButton`,
    defaultMessage: 'Lock card',
  },
})
